module.exports = __webpack_public_path__ + "wap/img/entrance.f613e57d.png";